/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LiveKitSipDispatchRule } from '../../models/live-kit-sip-dispatch-rule';

export interface ApiAdminLivekitSipDispatchRulesGet$Params {
}

export function apiAdminLivekitSipDispatchRulesGet(http: HttpClient, rootUrl: string, params?: ApiAdminLivekitSipDispatchRulesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LiveKitSipDispatchRule>>> {
  const rb = new RequestBuilder(rootUrl, apiAdminLivekitSipDispatchRulesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LiveKitSipDispatchRule>>;
    })
  );
}

apiAdminLivekitSipDispatchRulesGet.PATH = '/api/Admin/livekit/sip/dispatch-rules';
